import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { instalarSenalDeScroll } from "@/lib/scrollHint";

// Se instala una sola vez para toda la app: las zonas que se deslizan de lado estan
// repartidas en varias pantallas y aparecen y desaparecen al navegar.
instalarSenalDeScroll();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
